import { service } from '@maia/insurance';
import { InsuranceDto } from '@maia/shared';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Insurance = Awaited<ReturnType<(typeof service)['getInsurance']>>;

export function getInsuranceOptions(
  guid: string,
  initialData: QueryOptions<InsuranceDto>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['insurances', 'insurance', guid],
    queryFn: async () => await service.getInsurance(guid),
    initialData,
  });
}
